import React from "react";

import { PolicyMutation } from "../../layouts/policyMutation/PolicyMutation";

const PolicyMutationSitecore = (props) => <PolicyMutation fields={props.fields} />;

export default PolicyMutationSitecore;
